import moment from 'moment';
import jwtDecode from 'jwt-decode';

import {
    DEPOSIT_INTENT,
    WITHDRAWAL_INTENT,
    CUSTODIAN_ROLE_ID,
    BOT_VERIFIER_ROLE_ID,
    BOT_AUTHORIZER_ROLE_ID,
    COM_INITIATOR_ROLE_ID,
    COM_SIGNATORY_ONE_ROLE_ID,
    COM_SIGNATORY_TWO_ROLE_ID,
    COM_REP_ONE_ROLE_ID,
    BOT_MANAGER_CURRENCY_OPS,
    DIRECT_WITHDRAWAL_INTENT,
    DIRECT_DEPOSIT_INTENT,
    BOT_CUSTODIANS_ROLE_ID
    // BOT_MANAGEMENT_ROLE_ID
} from "../constants/Common";

import {
    ACTION_ENTRY,
    ACTION_CANCEL,
    ACTION_REJECT,
    ACTION_ACCEPT,
    ACTION_RETURN,
    ACTION_PAID,
    ACTION_SUCCESS,
    ACTION_ACCEPT_S1,
    ACTION_ACCEPT_S2,
    COMMERCIAL_BANK_SUBMIT,
    COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION,
    COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION,
    SAFE_CUSTODY_VERIFICATION,
    BACK_OFFICE_VERIFICATION,
    BACK_OFFICE_AUTHORIZATION,
    CBS_PAYMENT,
    BACK_OFFICE_PAY_AUTHORIZATION,
    SAFE_CUSTODY_DATE_CONFIRMATION,
    SAFE_CUSTODY_REP_WITHDRAWAL,
    SAFE_CUSTODY_SCC_WITHDRAWAL,
    //BOT_VERIFIER_WITHDRAWAL_CONFIRMATION,
    //BOT_AUTHORIZER_WITHDRAWAL_CONFIRMATION,
    SAFE_CUSTODY_REP_DEPOSIT,
    SAFE_CUSTODY_SCC_DEPOSIT,
    SAFE_CUSTODY_BDFORM_SUBMIT,
    BOT_VERIFIER_CONFIRMATION,
    BOT_AUTHORIZER_CONFIRMATION,
    INTENT_COMPLETED,
    BOT_MANAGER_OP_APPROVAL,
    BOT_AM_AUTHORIZATION,
    BOT_TRX_COMMITED
} from '../constants/WorkFlowStatuses';


// const _user = sessionStorage.getItem('user');
// const authUser = (typeof _user === 'string') ? JSON.parse(_user) : _user;

let _comSignatories = [COM_SIGNATORY_ONE_ROLE_ID, COM_SIGNATORY_TWO_ROLE_ID];

const depositKeys = [DEPOSIT_INTENT, DIRECT_DEPOSIT_INTENT];
//const withdrawalKeys = [WITHDRAWAL_INTENT, DIRECT_WITHDRAWAL_INTENT];

const unformatNumber = (number) => {
    return number.replace(/,/g, "");
}

const formatNumber = (number) => {
    let kk = parseInt(number);
    return new Intl.NumberFormat().format(kk.toExponential().replace(/,/g, ""))
}

const formatNumber2 = (number) => {
    return new Intl.NumberFormat().format(number.toString().replace(/,/g, ""))
}

const tokenDecode = (token) => {
    var decodeToken = JSON.stringify(jwtDecode(token));
    return decodeToken;
}

const strTrim = (x) => {
    return x.replace(/^\s+|\s+$/gm, '');
}


const reverseString = (str) => {
    return str.split("").reverse().join("");
}

const weekDates = (current = null) => {
    let _current = (current !== null) ? new Date(current) : new Date();
    let weekDates = [];

    for (let i = 1; i <= 7; i++) {
        let first = _current.getDate() - _current.getDay() + i;
        let day = new Date(_current.setDate(first)).toISOString().slice(0, 10);
        weekDates.push(day);
    }

    return weekDates;
}

const getPasswordAge = (lastPasswordUpdateTimestamp) => {
    //let differenceInDays = Math.ceil(Math.abs(new Date() - new Date(lastPasswordUpdateTimestamp * 1000)) / (1000 * 60 * 60 * 24));==epoch
    let differenceInDays = Math.ceil(Math.abs(new Date() - new Date(lastPasswordUpdateTimestamp)) / (1000 * 60 * 60 * 24));
    return parseInt(differenceInDays);
}

const randomizePwd = (length) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

const getCustomConsignmentStatus = (_status, consignmetType) => {
    let customStatus;
    if (_status == 'submitted') {
        customStatus = 'Submitted';
    } else if (_status == 'authorized') {
        customStatus = 'Authorized';
    } else if (_status == 'rejected') {
        customStatus = 'Rejected';
    } else if (_status == 'intransit' && consignmetType == 3) {
        customStatus = 'Intransit to SCC';
    } else if (_status == 'intransit' && consignmetType == 4) {
        customStatus = 'Intransit to BOT';
    } else if (_status == 'completed') {
        customStatus = 'Completed';
    } else if (_status == 'source_escorter1_signed' && consignmetType == 3) {
        customStatus = 'First Escorter At BOT(Source) Signed';
    } else if (_status == 'source_escorter2_signed' && consignmetType == 3) {
        customStatus = 'Second Escorter At BOT(Source) Signed';
    } else if (_status == 'destination_escorter1_signed' && consignmetType == 3) {
        customStatus = 'First Escorter At SCC(Destination) Signed';
    } else if (_status == 'destination_escorter2_signed' && consignmetType == 3) {
        customStatus = 'Second Escorter At SCC(Destination) Signed';
    } else if (_status == 'source_custodian1_signed' && consignmetType == 3) {
        customStatus = 'First Custodian At BOT(Source) Signed';
    } else if (_status == 'source_custodian2_signed' && consignmetType == 3) {
        customStatus = 'Second Custodian At BOT(Source) Signed';
    } else if (_status == 'destination_custodian1_signed' && consignmetType == 3) {
        customStatus = 'First Custodian At SCC(Destination) Signed';
    } else if (_status == 'destination_custodian2_signed' && consignmetType == 3) {
        customStatus = 'Second Custodian At SCC(Destination) Signed';
    }
    else if (_status == 'source_escorter1_signed' && consignmetType == 4) {
        customStatus = 'First Escorter At SCC(Source) Signed';
    } else if (_status == 'source_escorter2_signed' && consignmetType == 4) {
        customStatus = 'Second Escorter At SCC(Source) Signed';
    } else if (_status == 'destination_escorter1_signed' && consignmetType == 4) {
        customStatus = 'First Escorter At BOT(Destination) Signed';
    } else if (_status == 'destination_escorter2_signed' && consignmetType == 4) {
        customStatus = 'Second Escorter At BOT(Destination) Signed';
    } else if (_status == 'source_custodian1_signed' && consignmetType == 4) {
        customStatus = 'First Custodian At SCC(Source) Signed';
    } else if (_status == 'source_custodian2_signed' && consignmetType == 4) {
        customStatus = 'Second Custodian At SCC(Source) Signed';
    } else if (_status == 'destination_custodian1_signed' && consignmetType == 4) {
        customStatus = 'First Custodian At BOT(Destination) Signed';
    } else if (_status == 'destination_custodian2_signed' && consignmetType == 4) {
        customStatus = 'Second Custodian At BOT(Destination) Signed';
    }

    return customStatus;
}

const getOriginalConsignmentStatus = (_status) => {
    let customStatus;
    if (_status == 'Submitted') {
        customStatus = 'submitted';
    } else if (_status == 'Authorized') {
        customStatus = 'authorized';
    } else if (_status == 'Rejected') {
        customStatus = 'rejected';
    } else if (_status == 'Intransit to SCC') {
        customStatus = 'intransit';
    } else if (_status == 'Intransit to BOT') {
        customStatus = 'intransit';
    } else if (_status == 'Completed') {
        customStatus = 'completed';
    } else if (_status == 'First Escorter At BOT(Source) Signed') {
        customStatus = 'source_escorter1_signed';
    } else if (_status == 'Second Escorter At BOT(Source) Signed') {
        customStatus = 'source_escorter2_signed';
    } else if (_status == 'First Escorter At SCC(Destination) Signed') {
        customStatus = 'destination_escorter1_signed';
    } else if (_status == 'Second Escorter At SCC(Destination) Signed') {
        customStatus = 'destination_escorter2_signed';
    } else if (_status == 'First Custodian At BOT(Source) Signed') {
        customStatus = 'source_custodian1_signed';
    } else if (_status == 'Second Custodian At BOT(Source) Signed') {
        customStatus = 'source_custodian2_signed';
    } else if (_status == 'First Custodian At SCC(Destination) Signed') {
        customStatus = 'destination_custodian1_signed';
    } else if (_status == 'Second Custodian At SCC(Destination) Signed') {
        customStatus = 'destination_custodian2_signed';
    }
    else if (_status == 'First Escorter At SCC(Source) Signed') {
        customStatus = 'source_escorter1_signed';
    } else if (_status == 'Second Escorter At SCC(Source) Signed') {
        customStatus = 'source_escorter2_signed';
    } else if (_status == 'First Escorter At BOT(Destination) Signed') {
        customStatus = 'destination_escorter1_signed';
    } else if (_status == 'Second Escorter At BOT(Destination) Signed') {
        customStatus = 'destination_escorter2_signed';
    } else if (_status == 'First Custodian At SCC(Source) Signed') {
        customStatus = 'source_custodian1_signed';
    } else if (_status == 'Second Custodian At SCC(Source) Signed') {
        customStatus = 'source_custodian2_signed';
    } else if (_status == 'First Custodian At BOT(Destination) Signed') {
        customStatus = 'destination_custodian1_signed';
    } else if (_status == 'Second Custodian At BOT(Destination) Signed') {
        customStatus = 'destination_custodian2_signed';
    }

    return customStatus;
}

const translateEnteredAmount = (input) => {
    let _amount = input.toString().length > 1 ? unformatNumber(input.slice(0, -1)) : unformatNumber(input);
    let char = input.slice(-1).toUpperCase();
    let _actualAmount = 0;

    switch (char) {
        case "H":
            return (_actualAmount = _amount * 100);
        case "K":
            return (_actualAmount = _amount * 1000);
        case "M":
            return (_actualAmount = _amount * 1000000);
        case "B":
            return (_actualAmount = _amount * 1000000000);
        case "T":
            return (_actualAmount = _amount * 1000000000000);
        case "Z":
            return (_actualAmount = _amount * 1000000000000000);
        default:
            //Ignore the character
            return (_actualAmount = _amount);
    }
};

const base64FileDetails = (base64String) => {

    let _strings = base64String.split(",");
    let file = {};
    switch (_strings[0]) {//check files's extension
        case "data:application/pdf;base64":
            file = {
                ...file,
                type: 'Document',
                extension: "pdf"
            };
            break;
        case "data:image/jpeg;base64":
            file = {
                ...file,
                type: 'Image',
                extension: "jpeg"
            };
            break;
        case "data:image/png;base64":
            file = {
                ...file,
                type: 'Image',
                extension: "png"
            };
            break;
        default://should write cases for more images types
            file = {
                ...file,
                type: 'Image',
                extension: "jpg"
            };
            break;
    }

    return file;
}

const intentStatus = (stage, status, intent_type = null) => {
    let displayStatus = status;

    switch (stage) {
        case COMMERCIAL_BANK_SUBMIT:
            if (status === ACTION_ENTRY) {
                displayStatus = "ENTRY"
            }
            if (status === ACTION_CANCEL) {
                displayStatus = "CANCELLED"
            }
            if (status === ACTION_ACCEPT) {
                displayStatus = "INITIATED"
            }
            break;
        case COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION:
            if (status === ACTION_ACCEPT) {
                displayStatus = "SIGNATORY ONE ACCEPTED"
            }
            if (status === ACTION_REJECT) {
                displayStatus = "SIGNATORY ONE REJECTED"
            }
            break;
        case COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION:
            if (status === ACTION_ACCEPT) {
                displayStatus = "SIGNATORY TWO ACCEPTED"
            }
            if (status === ACTION_REJECT) {
                displayStatus = "SIGNATORY TWO REJECT"
            }
            break;
        case SAFE_CUSTODY_VERIFICATION:
            if (status === ACTION_ACCEPT) {
                displayStatus = "CUSTODIAN VERIFIED"
            }
            if (status === ACTION_REJECT) {
                displayStatus = "CUSTODIAN REJECTED"
            }
            break;
        case BACK_OFFICE_VERIFICATION:
            if (status === ACTION_ACCEPT) {
                displayStatus = "BOT VERIFIED REQUEST"
            }
            if (status === ACTION_REJECT) {
                displayStatus = "BOT REJECTED  REQUEST"
            }
            break;
        case BACK_OFFICE_AUTHORIZATION:
            if (status === ACTION_ACCEPT) {
                displayStatus = "BOT AUTHORIZED REQUEST"
            }
            if (status === ACTION_RETURN) {
                displayStatus = "RETURNED FOR CORRECTION"
            }
            if (status === ACTION_REJECT) {
                displayStatus = "BOT REJECTED REQUEST"
            }
            break;
        case SAFE_CUSTODY_BDFORM_SUBMIT:
            if (status === ACTION_ACCEPT) {
                displayStatus = (depositKeys.includes(intent_type)) ? "AMOUNT DEPOSITED" : "AMOUNT WITHDRAWN"
            }

            if (status === ACTION_RETURN) {
                displayStatus = "BD FORM CORRECTION"
            }
            break;
        case CBS_PAYMENT:
            if (status === ACTION_PAID) {
                displayStatus = "ACCOUNT FUNDED"
            }
            break;
        case BACK_OFFICE_PAY_AUTHORIZATION:
            if (status === ACTION_ACCEPT) {
                displayStatus = "BOT VERIFIED PAYMENT "
            }
            if (status === ACTION_REJECT) {
                displayStatus = "BOT REJECTED PAYMENT "
            }
            if (status === ACTION_RETURN) {
                displayStatus = "BD FORM CORRECTION"
            }
            break;
        case SAFE_CUSTODY_DATE_CONFIRMATION:
            if (status === ACTION_ACCEPT) {
                displayStatus = "CUSTODIAN DATE CONFIRMED"
            }
            if (status === ACTION_RETURN) {
                displayStatus = "BD FORM CORRECTION"
            }
            break;
        case SAFE_CUSTODY_REP_WITHDRAWAL:
            if (status === ACTION_ACCEPT_S1) {
                displayStatus = "REPRESENTATIVE ONE SIGNED"
            }
            if (status === ACTION_ACCEPT_S2) {
                displayStatus = "REPRESENTATIVE TWO SIGNED"
            }
            break;
        case SAFE_CUSTODY_REP_DEPOSIT:
            if (status === ACTION_ACCEPT_S1) {
                displayStatus = "REPRESENTATIVE ONE SIGNED"
            }
            if (status === ACTION_ACCEPT_S2) {
                displayStatus = "REPRESENTATIVE TWO SIGNED"
            }
            break;

        case SAFE_CUSTODY_SCC_WITHDRAWAL:
            if (status === ACTION_ACCEPT_S1) {
                displayStatus = "CUSTODIAN ONE SIGNED"
            }
            if (status === ACTION_ACCEPT_S2) {
                displayStatus = "CUSTODIAN TWO SIGNED"
            }
            break;

        case SAFE_CUSTODY_SCC_DEPOSIT:
            if (status === ACTION_ACCEPT_S1) {
                displayStatus = "CUSTODIAN ONE SIGNED"
            }
            if (status === ACTION_ACCEPT_S2) {
                displayStatus = "CUSTODIAN TWO SIGNED"
            }
            break;

        case BOT_VERIFIER_CONFIRMATION:
            if (status === ACTION_ACCEPT) {
                displayStatus = "BOT POST VERIFIED"
            }
            if (status === ACTION_REJECT) {
                displayStatus = "BOT POST VERIFIED"
            }
            break;

        case BOT_AUTHORIZER_CONFIRMATION:
            if (status === ACTION_ACCEPT) {
                displayStatus = "TRANSACTION PROCESSING"
            }
            if (status === ACTION_SUCCESS) {
                displayStatus = "TRANSACTION PROCESSING"
            }
            break;
        case BOT_MANAGER_OP_APPROVAL:
            if (status === ACTION_ACCEPT) {
                displayStatus = "TRANSACTION APPROVED"
            }
            if (status === ACTION_REJECT) {
                displayStatus = "TRANSACTION REJECTED"
            }
            break;
        case BOT_AM_AUTHORIZATION:
            if (status === ACTION_ACCEPT) {
                displayStatus = "TRANSACTION VERIFIED"
            }
            if (status === ACTION_REJECT) {
                displayStatus = "TRANSACTION REJECTED"
            }
            if (status === ACTION_RETURN) {
                displayStatus = "RETURNED FOR CORRECTION"
            }
            break;
        case INTENT_COMPLETED:
            if (status === ACTION_ACCEPT) {
                displayStatus = "COMPLETED"
            }
            if (status === ACTION_REJECT) {
                displayStatus = "REJECTED"
            }
            break;
        default:
            break;
    }

    return displayStatus;

}

const getAllStagesByRole = (roleId) => {
    //Happy path pure workflow to be implemented during phase ii
    //-- Later to be moved to db
    let depositStages = [];
    let withdrawStages = [];
    // //For Commercial to branches direct
    let directDepositStages = [];
    let directWithdrawStages = [];

    switch (roleId) {
        case COM_INITIATOR_ROLE_ID://CB Initiator
            depositStages = [COMMERCIAL_BANK_SUBMIT, COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION, COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION,
                SAFE_CUSTODY_VERIFICATION, BACK_OFFICE_VERIFICATION, BACK_OFFICE_AUTHORIZATION, SAFE_CUSTODY_DATE_CONFIRMATION
            ];
            directDepositStages = [BOT_MANAGER_OP_APPROVAL];

            withdrawStages = [
                COMMERCIAL_BANK_SUBMIT, COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION, COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION,
                SAFE_CUSTODY_VERIFICATION, BACK_OFFICE_VERIFICATION, BACK_OFFICE_AUTHORIZATION, SAFE_CUSTODY_DATE_CONFIRMATION,
                CBS_PAYMENT, BACK_OFFICE_PAY_AUTHORIZATION
            ];
            directWithdrawStages = [BOT_MANAGER_OP_APPROVAL];
            break;
        case COM_SIGNATORY_ONE_ROLE_ID://CB_Signatory1

            depositStages = [COMMERCIAL_BANK_SUBMIT];
            withdrawStages = [COMMERCIAL_BANK_SUBMIT];

            break;
        case COM_SIGNATORY_TWO_ROLE_ID://CB_Signatory2

            depositStages = [COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION];
            withdrawStages = [COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION];

            break;
        case CUSTODIAN_ROLE_ID://SC_Custodian

            depositStages = [
                COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION, BACK_OFFICE_AUTHORIZATION, SAFE_CUSTODY_DATE_CONFIRMATION
            ];

            withdrawStages = [
                COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION, BACK_OFFICE_AUTHORIZATION, BACK_OFFICE_PAY_AUTHORIZATION
            ];

            break;
        case BOT_VERIFIER_ROLE_ID://BOT_Verifier

            depositStages = [
                SAFE_CUSTODY_VERIFICATION, SAFE_CUSTODY_BDFORM_SUBMIT
            ];

            directDepositStages = [BOT_AM_AUTHORIZATION, BACK_OFFICE_AUTHORIZATION, SAFE_CUSTODY_BDFORM_SUBMIT];

            withdrawStages = [
                SAFE_CUSTODY_VERIFICATION, CBS_PAYMENT, SAFE_CUSTODY_BDFORM_SUBMIT
            ];

            directWithdrawStages = [BOT_AM_AUTHORIZATION, BACK_OFFICE_AUTHORIZATION, CBS_PAYMENT, BACK_OFFICE_PAY_AUTHORIZATION, SAFE_CUSTODY_BDFORM_SUBMIT];
            break;
        case BOT_AUTHORIZER_ROLE_ID://BOT_Authorizer
            //BOT_AUTHORIZER_CONFIRMATION
            depositStages = [
                BACK_OFFICE_VERIFICATION, BOT_VERIFIER_CONFIRMATION
            ];
            directDepositStages = [BOT_MANAGER_OP_APPROVAL, SAFE_CUSTODY_DATE_CONFIRMATION];

            withdrawStages = [
                BACK_OFFICE_VERIFICATION, BOT_VERIFIER_CONFIRMATION
            ];
            directWithdrawStages = [BOT_MANAGER_OP_APPROVAL, SAFE_CUSTODY_DATE_CONFIRMATION];
            break;
        case BOT_MANAGER_CURRENCY_OPS://BOT_MOPS_MCY
            directDepositStages = [COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION];
            directWithdrawStages = [COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION];
            break;

        case BOT_CUSTODIANS_ROLE_ID:
            directWithdrawStages = [BOT_AM_AUTHORIZATION, BACK_OFFICE_AUTHORIZATION, CBS_PAYMENT, BACK_OFFICE_PAY_AUTHORIZATION, SAFE_CUSTODY_BDFORM_SUBMIT];
            directDepositStages = [BOT_AM_AUTHORIZATION, BACK_OFFICE_AUTHORIZATION, SAFE_CUSTODY_BDFORM_SUBMIT];
            break;
        default:
            break;
    }

    let stages = {
        depositStages: [...depositStages, ...directDepositStages],
        withdrawStages: [...withdrawStages, ...directWithdrawStages]
    }

    return stages;

}


const stageApprovalButtons = (intentType, role, stage, status, signatory1Id = null, s1Date = null, signatory2Id = null, s2Date = null, userId = null) => {

    let btnsObj = {
        confirmDate: false,
        uploadBDForm: false,
        buttons: null,
        downloadBD11Form: false,
        downloadBD55Form: false,
        canChangeDenominations: false,
        shouldCheckLimit: false
    }

    let _comSignatories = [COM_SIGNATORY_ONE_ROLE_ID, COM_SIGNATORY_TWO_ROLE_ID];

    let confirmed = (status === BOT_AUTHORIZER_CONFIRMATION || status === ACTION_CANCEL || status === ACTION_REJECT) ? true : false;

    switch (stage) {
        case COMMERCIAL_BANK_SUBMIT:
            //Visible to only CB ==> 1: bank officers --Orignators
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }
            //Will be presented to Signatory One --Modified to enable AA,AB && BB
            if (_comSignatories.includes(role) && status !== ACTION_CANCEL) {
                //Signatories -- check those assigned to user
                if (signatory1Id === userId && s1Date === null) {
                    btnsObj = {
                        ...btnsObj,
                        buttons: ['ACCEPT', 'REJECT']
                    }
                }
            }
            break;
        case COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }
            //Visible to CB ==> 3: CB --Signatory Two
            if (_comSignatories.includes(role) && status === ACTION_ACCEPT) {

                if (signatory2Id === userId && s2Date === null && s1Date !== null) {
                    btnsObj = {
                        ...btnsObj,
                        buttons: ['ACCEPT', 'REJECT']
                    }
                }
            }
            break;
        case COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }
            //Visible to CB ==> 3: CB --Signatory Two
            if (role === CUSTODIAN_ROLE_ID && status === ACTION_ACCEPT) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT', 'REJECT']
                }
            }
            break;
        case SAFE_CUSTODY_VERIFICATION:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }
            //Visible to SC ==> 4: Safe Custody --Custodians
            if (role === BOT_VERIFIER_ROLE_ID && status === ACTION_ACCEPT) {
                if (intentType === WITHDRAWAL_INTENT) {
                    btnsObj = {
                        ...btnsObj,
                        canChangeDenominations: true,
                        shouldCheckLimit: true,
                    }
                } else {
                    btnsObj = {
                        ...btnsObj,
                        shouldCheckLimit: true,
                        buttons: ['ACCEPT', 'REJECT']
                    }
                }
            }
            break;
        case BACK_OFFICE_VERIFICATION:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    show: true,
                    buttons: ['CANCEL']
                }
            }
            if (role === BOT_AUTHORIZER_ROLE_ID && status === ACTION_ACCEPT) {
                btnsObj = {
                    ...btnsObj,
                    show: true,
                    buttons: ['ACCEPT', 'REJECT']
                }
            }
            break;
        case BACK_OFFICE_AUTHORIZATION:
            //The next stage here depends on the intent type
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }
            if (role === CUSTODIAN_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    confirmDate: true
                }
            }

            break;
        case CBS_PAYMENT:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }
            //Visible to BOT ==> 5: BOT --Verifier
            //Move to next if role and previous status allows
            //Expecting this stage with status ACTION_PAID
            if (role === BOT_VERIFIER_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT', 'REJECT']
                }
            }
            break;
        case BACK_OFFICE_PAY_AUTHORIZATION://for withdraw
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                if (intentType === WITHDRAWAL_INTENT && status === ACTION_ACCEPT) {
                    btnsObj = {
                        ...btnsObj,
                        downloadBD11Form: true
                    }
                }
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }

            //Move to next if role and previous status allows
            //if (role === 4) {//not button rather then saving changes
            if (role === CUSTODIAN_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    uploadBDForm: true
                }
            }
            break;
        case SAFE_CUSTODY_DATE_CONFIRMATION:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                if (intentType === DEPOSIT_INTENT && status === ACTION_ACCEPT) {
                    btnsObj = {
                        ...btnsObj,
                        downloadBD55Form: true
                    }
                }
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }
            //Others -- Incase of deposit
            if (role === CUSTODIAN_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    uploadBDForm: true
                }
            }
            break;
        //Should not be able to cancel from here upwards
        //as actual action already taken place
        case SAFE_CUSTODY_BDFORM_SUBMIT:

            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                // btnsObj = {
                //     ...btnsObj,
                //     buttons: ['CANCEL']
                // }
            }
            if (role === BOT_VERIFIER_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT', 'RETURN'] //, 'REJECT'-- advised to remove reject for now, to be handled in phase II
                }
            }
            break;
        case SAFE_CUSTODY_REP_WITHDRAWAL:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                // btnsObj = {
                //     ...btnsObj,
                //     buttons: ['CANCEL']
                // }
            }
            //Others
            if ((role === COM_REP_ONE_ROLE_ID || role === CUSTODIAN_ROLE_ID) && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT']
                }
            }

            break;
        case SAFE_CUSTODY_REP_DEPOSIT:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                // btnsObj = {
                //     ...btnsObj,
                //     buttons: ['CANCEL']
                // }
            }
            //Others
            if ((role === COM_REP_ONE_ROLE_ID || role === CUSTODIAN_ROLE_ID) && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT']
                }
            }

            break;
        case SAFE_CUSTODY_SCC_WITHDRAWAL:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                // btnsObj = {
                //     ...btnsObj,
                //     buttons: ['CANCEL']
                // }
            }
            //Others - Custodians sign
            if (role === CUSTODIAN_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT']
                }
            }
            if (role === BOT_VERIFIER_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT']//, 'REJECT'
                }
            }
            break;
        case SAFE_CUSTODY_SCC_DEPOSIT:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                // btnsObj = {
                //     ...btnsObj,
                //     buttons: ['CANCEL']
                // }
            }
            //Others - Custodians sign
            if (role === CUSTODIAN_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT']
                }
            }
            if (role === BOT_VERIFIER_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT']//, 'REJECT'
                }
            }
            break;
        case BOT_VERIFIER_CONFIRMATION:

            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                // btnsObj = {
                //     ...btnsObj,
                //     buttons: ['CANCEL']
                // }
            }
            //
            if (role === BOT_AUTHORIZER_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT', 'RETURN']//, 'REJECT'
                }
            }
            break;
        case BOT_AUTHORIZER_CONFIRMATION:

            if (role === BOT_AUTHORIZER_ROLE_ID && status === ACTION_SUCCESS && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT']
                }
            }
            break;
        default:
            break;
    }

    return btnsObj;
}

//For commercial bank direct deposit and withdrawal
const stageApprovalButtonsDirectBanking = (intentType, role, stage, status, signatory1Id = null, s1Date = null, signatory2Id = null, s2Date = null, userId = null, lastUpdatedBy = null) => {

    let btnsObj = {
        confirmDate: false,
        uploadBDForm: false,
        buttons: null,
        downloadBDForm: false,
        canChangeDenominations: false
    }

    let _comSignatories = [COM_SIGNATORY_ONE_ROLE_ID, COM_SIGNATORY_TWO_ROLE_ID];

    let confirmed = (status === BOT_TRX_COMMITED || status === ACTION_CANCEL || status === ACTION_REJECT) ? true : false;

    switch (stage) {
        case COMMERCIAL_BANK_SUBMIT:
            //Visible to only CB ==> 1: bank officers --Orignators
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }
            //Will be presented to Signatory One --Modified to enable AA,AB && BB
            if (_comSignatories.includes(role) && status !== ACTION_CANCEL) {
                //Signatories -- check those assigned to user
                if (signatory1Id === userId && s1Date === null) {
                    btnsObj = {
                        ...btnsObj,
                        buttons: ['ACCEPT', 'REJECT']
                    }
                }
            }
            break;
        case COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }
            //Visible to CB ==> 3: CB --Signatory Two
            if (_comSignatories.includes(role) && status === ACTION_ACCEPT) {

                if (signatory2Id === userId && s2Date === null && s1Date !== null) {
                    btnsObj = {
                        ...btnsObj,
                        buttons: ['ACCEPT', 'REJECT']
                    }
                }
            }
            break;
        case COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }

            if (role === BOT_MANAGER_CURRENCY_OPS && status === ACTION_ACCEPT) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT', 'REJECT']
                }
            }
            break;
        case BOT_MANAGER_OP_APPROVAL:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }
            if (role === BOT_AUTHORIZER_ROLE_ID && status === ACTION_ACCEPT) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT']
                }
            }
            break;
        case BOT_AM_AUTHORIZATION:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    show: true,
                    buttons: ['CANCEL']
                }
            }
            //Confirm date and change deniminations incase of withdrawal
            if ((role === BOT_VERIFIER_ROLE_ID || role === BOT_CUSTODIANS_ROLE_ID) && (status === ACTION_ACCEPT || status === ACTION_RETURN)) {
                if (intentType === DIRECT_WITHDRAWAL_INTENT) {
                    btnsObj = {
                        ...btnsObj,
                        canChangeDenominations: true
                    }
                }
                btnsObj = {
                    ...btnsObj,
                    show: true,
                    confirmDate: true,
                    // buttons: ['ACCEPT']
                }
            }
            break;
        case SAFE_CUSTODY_DATE_CONFIRMATION:
            //The next stage here depends on the intent type
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }

            if (role === BOT_AUTHORIZER_ROLE_ID && status === ACTION_ACCEPT) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT', 'RETURN']
                }
            }
            break;
        case BACK_OFFICE_AUTHORIZATION:
            //The next stage here depends on the intent type
            //For deposit cb should download bd55
            //For withdrawal cb should download MT202 Message format
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                if (intentType === DIRECT_DEPOSIT_INTENT && status === ACTION_ACCEPT) {
                    btnsObj = {
                        ...btnsObj,
                        downloadBD55Form: true
                    }
                }
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }

            if (intentType === DIRECT_DEPOSIT_INTENT) {
                if (role === BOT_VERIFIER_ROLE_ID && !confirmed) {
                    if (status === ACTION_RETURN) {
                        btnsObj = {
                            ...btnsObj,
                            confirmDate: true
                        }
                    } else {
                        btnsObj = {
                            ...btnsObj,
                            buttons: ['REJECT'],
                            uploadBDForm: true
                        }
                    }
                }
            }

            if (intentType === DIRECT_WITHDRAWAL_INTENT) {
                if (role === BOT_VERIFIER_ROLE_ID && !confirmed) {
                    if (status === ACTION_RETURN) {
                        btnsObj = {
                            ...btnsObj,
                            confirmDate: true
                        }
                    }
                }
            }
            break;
        case SAFE_CUSTODY_BDFORM_SUBMIT:
            //The next stage here depends on the intent type
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }
            if (role === BOT_VERIFIER_ROLE_ID) {
                if (userId !== lastUpdatedBy && !confirmed && status === ACTION_ACCEPT) {
                    btnsObj = {
                        ...btnsObj,
                        buttons: ['ACCEPT', 'RETURN']
                    }
                }

                if (userId !== lastUpdatedBy && !confirmed && status === ACTION_RETURN) {
                    btnsObj = {
                        ...btnsObj,
                        uploadBDForm: true
                    }
                }
            }
            break;
        case CBS_PAYMENT:
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }
            //Visible to BOT ==> 5: BOT --Verifier
            //Move to next if role and previous status allows
            //Expecting this stage with status ACTION_PAID
            if (role === BOT_VERIFIER_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['ACCEPT', 'REJECT']
                }
            }
            break;
        case BACK_OFFICE_PAY_AUTHORIZATION://for withdraw
            if (role === COM_INITIATOR_ROLE_ID && !confirmed) {
                if (intentType === DIRECT_WITHDRAWAL_INTENT && status === ACTION_ACCEPT) {
                    btnsObj = {
                        ...btnsObj,
                        downloadBD11Form: true
                    }
                }
                btnsObj = {
                    ...btnsObj,
                    buttons: ['CANCEL']
                }
            }

            //Move to next if role and previous status allows
            //if (role === 5) {//not button rather then saving changes
            if (role === BOT_VERIFIER_ROLE_ID && !confirmed) {
                btnsObj = {
                    ...btnsObj,
                    buttons: ['REJECT'],
                    uploadBDForm: true
                }
            }
            break;
        default:
            break;
    }

    return btnsObj;
}

const intentWorkingStage = (intentType, stage, status, action = ACTION_ACCEPT, role, userId, custodianTwoId = null) => {
    let workingStage = {
        stage: stage,
        action: action,//Current action ==> For future use
        extraPatches: null,
        successDisplayMessage: `Intent information updated successfully.`
    };

    let confirmed = (stage === BOT_AUTHORIZER_CONFIRMATION || stage === INTENT_COMPLETED || action === ACTION_CANCEL) ? true : false;

    if (role === COM_INITIATOR_ROLE_ID && action === ACTION_CANCEL && !confirmed) {
        workingStage = { ...workingStage, successDisplayMessage: `Intent request cancelled successfully.` }
    } else {
        //Withdrawal workflow
        if (intentType === WITHDRAWAL_INTENT) {
            switch (stage) {
                case COMMERCIAL_BANK_SUBMIT:
                    //Visible to CB ==> 1: bank officers --Orignators
                    if (role === COM_INITIATOR_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: stage
                        }
                    }
                    //Move to next if role and previous status allows
                    //2 ==> CB Signatory One
                    if (_comSignatories.includes(role)) {
                        workingStage = {
                            ...workingStage,
                            stage: COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION,
                            extraPatches: {
                                "SIGNATORY1": userId,
                                "SIGNATORY1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully forwarded to signatory two for approval.`
                        }
                    }
                    break;
                case COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION:

                    //Move to next if role and previous status allows
                    //3 ==>  CB --Signatory two
                    if (_comSignatories.includes(role)) {
                        workingStage = {
                            ...workingStage,
                            stage: COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION,
                            extraPatches: {
                                "SIGNATORY2": userId,
                                "SIGNATORY2_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully forwarded to custodian for approval.`
                        }
                    }
                    break;
                case COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION:
                    //Visible to CB ==> 3: CB --Signatory Two
                    if (_comSignatories.includes(role)) {
                        workingStage = {
                            ...workingStage,
                            stage: stage
                        }
                    }

                    //Move to next if role and previous status allows
                    //4 ==> SC Custodian
                    if (role === CUSTODIAN_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: SAFE_CUSTODY_VERIFICATION,
                            extraPatches: {
                                "CUSTODIAN1": userId,
                                "CUSTODIAN1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a"),
                                "CUSTODIAN2": custodianTwoId,
                                "CUSTODIAN2_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully forwarded BOT for approval.`
                        }
                    }
                    break;
                case SAFE_CUSTODY_VERIFICATION:
                    //Visible to SC ==> 4: Safe Custody --Custodians
                    if (role === CUSTODIAN_ROLE_ID) {
                        workingStage = { ...workingStage, stage: stage }
                    }

                    //Move to next if role and previous status allows
                    //5 ==> BOT_Verifier
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: BACK_OFFICE_VERIFICATION,
                            extraPatches: {
                                "VERIFIER": userId,
                                "VERIFIED_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                            },
                            successDisplayMessage: `Intent denominations breakdown successfully confirmed.`
                        }
                    }
                    break;
                case BACK_OFFICE_VERIFICATION:
                    //Visible to BOT ==> 5: BOT --Verfier
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: stage
                        }
                    }
                    //Move to next if role and previous status allows
                    //6 ==> BOT_Verifier
                    if (role === BOT_AUTHORIZER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: BACK_OFFICE_AUTHORIZATION,
                            extraPatches: {
                                "AUTHORIZER": userId,
                                "AUTHORIZED_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent requested successfully approved.`
                        }
                    }
                    break;
                case BACK_OFFICE_AUTHORIZATION:
                    //Visible to BOT ==> 6: BOT --Authorizer
                    if (role === BOT_AUTHORIZER_ROLE_ID) {
                        workingStage = { ...workingStage, stage: stage }
                    }

                    //New changes from MSDA
                    //Move to next if role and previous status allows
                    if (role === CUSTODIAN_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: SAFE_CUSTODY_DATE_CONFIRMATION,
                            successDisplayMessage: `Intent withdrawal date successfully confirmed.`
                        }
                    }

                    break;

                case SAFE_CUSTODY_DATE_CONFIRMATION:
                    //Visible to CM ==> 1: to Generate bd form,4 = Custodian
                    if (role === CUSTODIAN_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: stage
                        }
                    }
                    //
                    // if (role === 7) {
                    //     workingStage = {
                    //         ...workingStage,
                    //         stage: SAFE_CUSTODY_REP_WITHDRAWAL,
                    //         action: ACTION_ACCEPT_S1,
                    //         extraPatches: {
                    //             "REP1": userId,
                    //             "REP1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                    //         }
                    //     }
                    // }

                    //Move to next if role and previous status allows
                    //7 ==> CBS PAYMENT  WHICH IS HANDLED BY CBS

                    break;
                case CBS_PAYMENT:
                    //Visible to BOT ==> 5: BOT --Verifier
                    //Move to next if role and previous status allows
                    //Expecting this stage with status ACTION_PAID
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: BACK_OFFICE_PAY_AUTHORIZATION,
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Amount funded successfully confirmed.`
                        }
                    }
                    break;

                case BACK_OFFICE_PAY_AUTHORIZATION:
                    //Visible to BOT ==> 5: BOT --Verifier,4 = Custodian
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = { ...workingStage, stage: stage }
                    }
                    //Move to next if role and previous status allows

                    //Upload signed BD form
                    if (role === CUSTODIAN_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: SAFE_CUSTODY_BDFORM_SUBMIT,
                            successDisplayMessage: `Intent filled and signed BD11 form submitted successfully.`
                        }
                    }

                    break;
                case SAFE_CUSTODY_BDFORM_SUBMIT:

                    if (role === CUSTODIAN_ROLE_ID) {
                        workingStage = { ...workingStage, stage: stage }
                    }
                    //Move to next if role and previous status allows
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: (action === ACTION_RETURN) ? BACK_OFFICE_PAY_AUTHORIZATION : BOT_VERIFIER_CONFIRMATION,
                            successDisplayMessage: (action === ACTION_RETURN) ? `Intent returned to custodian for correction of the BD11 form uploaded.` : `Uploaded filled and signed BD11 form successfully verified.`
                        }
                    }

                    break
                // case SAFE_CUSTODY_REP_WITHDRAWAL:
                //     //Visible to CM Representatives ==> 7: to Generate bd form,4 = Custodian
                //     if (role === 7) {
                //         workingStage = {
                //             ...workingStage,
                //             stage: stage,
                //             action: ACTION_ACCEPT_S2,
                //             extraPatches: {
                //                 "REP2": userId,
                //                 "REP2_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                //             }
                //         }
                //     }
                //     //Move to next if role and previous status allows
                //     if (role === 4) {
                //         workingStage = {
                //             ...workingStage,
                //             stage: SAFE_CUSTODY_SCC_WITHDRAWAL,
                //             action: ACTION_ACCEPT_S1,
                //             extraPatches: {
                //                 "CUSTODIAN1": userId,
                //                 "CUSTODIAN1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                //             }
                //         }
                //     }

                //     break;
                // case SAFE_CUSTODY_SCC_WITHDRAWAL:
                //     //Visible to CM ==> 1: to Generate bd form,4 = Custodian
                //     if (role === 4) {
                //         workingStage = {
                //             ...workingStage,
                //             stage: stage,
                //             action: ACTION_ACCEPT_S2,
                //             extraPatches: {
                //                 "CUSTODIAN2": userId,
                //                 "CUSTODIAN2_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                //             }
                //         }
                //     }
                //     //Bo
                //     if (role === 5) {
                //         workingStage = {
                //             ...workingStage,
                //             stage: BOT_VERIFIER_WITHDRAWAL_CONFIRMATION,
                //         }
                //     }
                //     break;
                case BOT_VERIFIER_CONFIRMATION:
                    //Visible to CM ==> 1: to Generate bd form,4 = Custodian
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = { ...workingStage, stage: stage }
                    }

                    if (role === BOT_AUTHORIZER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: (action === ACTION_RETURN) ? SAFE_CUSTODY_BDFORM_SUBMIT : BOT_AUTHORIZER_CONFIRMATION,
                            successDisplayMessage: (action === ACTION_RETURN) ? `Intent returned to Verifier for correction.` : `Updated successfully and Transaction forwarded to CBS.`
                        }
                    }
                    break;
                case BOT_AUTHORIZER_CONFIRMATION:
                    //Visible to BT ==> 6: Authorizer for completion

                    if (role === BOT_AUTHORIZER_ROLE_ID & action === ACTION_ACCEPT) {
                        workingStage = {
                            ...workingStage,
                            stage: INTENT_COMPLETED,
                        }
                    }
                    break;
                default:
                    break;

            }
        }
        //Direct Withdrawal workflow
        if (intentType === DIRECT_WITHDRAWAL_INTENT) {
            switch (stage) {
                case COMMERCIAL_BANK_SUBMIT:
                    //Visible to CB ==> 1: bank officers --Orignators
                    if (role === COM_INITIATOR_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: stage
                        }
                    }
                    //Move to next if role and previous status allows
                    //2 ==> CB Signatory One
                    if (_comSignatories.includes(role)) {
                        workingStage = {
                            ...workingStage,
                            stage: COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION,
                            extraPatches: {
                                "SIGNATORY1": userId,
                                "SIGNATORY1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully forwarded to signatory two for approval.`
                        }

                    }
                    break;
                case COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION:

                    //Move to next if role and previous status allows
                    //3 ==>  CB --Signatory two
                    if (_comSignatories.includes(role)) {
                        workingStage = {
                            ...workingStage,
                            stage: COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION,
                            extraPatches: {
                                "SIGNATORY2": userId,
                                "SIGNATORY2_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully forwarded to BOT for approval.`
                        }
                    }
                    break;
                case COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION:
                    //Visible to CB ==> 3: CB --Signatory Two
                    if (_comSignatories.includes(role)) {
                        workingStage = {
                            ...workingStage,
                            stage: stage
                        }
                    }

                    //Move to next if role and previous status allows
                    //4 ==> SC Custodian
                    if (role === BOT_MANAGER_CURRENCY_OPS) {
                        workingStage = {
                            ...workingStage,
                            stage: BOT_AM_AUTHORIZATION,//BOT_MANAGER_OP_APPROVAL
                            extraPatches: {
                                "MANAGER": userId,
                                "MANAGER_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully approved.`
                        }
                    }

                    break;
                // case BOT_MANAGER_OP_APPROVAL:
                //     //Visible to SC ==> 4: Safe Custody --Custodians
                //     if (role === BOT_MANAGER_CURRENCY_OPS) {
                //         workingStage = { ...workingStage, stage: stage }
                //     }

                //     //Move to next if role and previous status allows
                //     //5 ==> BOT_Verifier
                //     if (role === BOT_AUTHORIZER_ROLE_ID) {
                //         workingStage = {
                //             ...workingStage,
                //             stage: BOT_AM_AUTHORIZATION,
                //             extraPatches: {
                //                 "AUTHORIZER": userId,
                //                 "AUTHORIZED_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                //             }
                //         }
                //     }
                //     break;
                case BOT_AM_AUTHORIZATION:
                    //Visible to BOT ==> 5: BOT --Verfier
                    if (role === BOT_AUTHORIZER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: stage
                        }
                    }
                    //Move to next if role and previous status allows
                    //6 ==> BOT_Verifier
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: SAFE_CUSTODY_DATE_CONFIRMATION,
                            extraPatches: {
                                "VERIFIER": userId,
                                "VERIFIED_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A"),
                            },
                            successDisplayMessage: `Intent withdrawal date and denominations breakdown successfully confirmed.`
                        }
                    }
                    break;
                case SAFE_CUSTODY_DATE_CONFIRMATION:
                    //Visible to CM ==> 1: to Generate bd form,4 = Custodian
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: stage
                        }
                    }
                    if (role === BOT_AUTHORIZER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: BACK_OFFICE_AUTHORIZATION,
                            extraPatches: {
                                "AUTHORIZER": userId,
                                "AUTHORIZED_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                            },
                            successDisplayMessage: (action === ACTION_RETURN) ? `Intent request returned to Custodian for correction.` : `Intent request successfully verified.`
                        }
                    }
                    break;
                case BACK_OFFICE_AUTHORIZATION:
                    if (role === BOT_VERIFIER_ROLE_ID && status === ACTION_RETURN) {
                        workingStage = {
                            ...workingStage,
                            stage: SAFE_CUSTODY_DATE_CONFIRMATION,
                            action: ACTION_ACCEPT,
                            extraPatches: {
                                "VERIFIER": userId,
                                "VERIFIED_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                            },
                            successDisplayMessage: `Intent withdrawal date and denominations breakdown successfully confirmed.`
                        }
                    }
                    break;
                case CBS_PAYMENT:
                    //Visible to BOT ==> 5: BOT --Verifier
                    //Move to next if role and previous status allows
                    //Expecting this stage with status ACTION_PAID
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: BACK_OFFICE_PAY_AUTHORIZATION,
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Amount funded successfully confirmed.`
                        }
                    }
                    break;
                case BACK_OFFICE_PAY_AUTHORIZATION:
                    //Upload signed BD form and commit 
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: SAFE_CUSTODY_BDFORM_SUBMIT,
                            extraPatches: {
                                "CUSTODIAN1": userId,
                                "CUSTODIAN1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                            },
                            successDisplayMessage: `Intent filled and signed BD11 form submitted successfully.`
                        }
                    }
                    break;
                case SAFE_CUSTODY_BDFORM_SUBMIT:
                    //Move to next if role and previous status allows
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        if (status === ACTION_RETURN) {
                            workingStage = {
                                ...workingStage,
                                stage: SAFE_CUSTODY_BDFORM_SUBMIT,
                                action: ACTION_ACCEPT,
                                extraPatches: {
                                    "CUSTODIAN1": userId,
                                    "CUSTODIAN1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                                },
                                successDisplayMessage: `Intent filled and signed BD11 form submitted successfully.`
                            }
                        } else {
                            workingStage = {
                                ...workingStage,
                                stage: (action === ACTION_RETURN) ? SAFE_CUSTODY_BDFORM_SUBMIT : BOT_AUTHORIZER_CONFIRMATION,
                                extraPatches: {
                                    "CUSTODIAN2": userId,
                                    "CUSTODIAN2_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                                },
                                successDisplayMessage: (action === ACTION_RETURN) ? `Intent successfully returned to custodian One for correction of the BD11 form submitted.` : `Uploaded filled and signed BD11 form successfully verified.`
                            }
                        }
                    }
                    break
                default:
                    workingStage = { ...workingStage, stage: stage }
                    break;

            }
        }

        //Deposit workflow
        if (intentType === DEPOSIT_INTENT) {

            switch (stage) {
                case COMMERCIAL_BANK_SUBMIT:
                    //Visible to CB ==> 1: bank officers --Orignators
                    if (role === COM_INITIATOR_ROLE_ID) {
                        workingStage = { ...workingStage, stage: stage }
                    }
                    //Move to next if role and previous status allows
                    //2 ==> CB Signatory One
                    if (_comSignatories.includes(role)) {

                        workingStage = {
                            ...workingStage,
                            stage: COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION,
                            extraPatches: {
                                "SIGNATORY1": userId,
                                "SIGNATORY1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully forwarded to signatory two for approval.`
                        }
                    }
                    break;
                case COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION:
                    //Visible to CB ==> 2: CB --Signatory One
                    if (_comSignatories.includes(role)) {
                        workingStage = {
                            ...workingStage,
                            stage: COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION,
                            extraPatches: {
                                "SIGNATORY2": userId,
                                "SIGNATORY2_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully forwarded to custodian for approval.`
                        }
                    }
                    break;
                case COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION:
                    //Visible to CB ==> 3: CB --Signatory Two
                    // if (role === COM_SIGNATORY_TWO_ROLE_ID) {
                    //     workingStage = {
                    //         ...workingStage,
                    //         stage: stage
                    //     }
                    // }

                    //Move to next if role and previous status allows
                    //4 ==> SC Custodian
                    if (role === CUSTODIAN_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: SAFE_CUSTODY_VERIFICATION,
                            extraPatches: {
                                "CUSTODIAN1": userId,
                                "CUSTODIAN1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a"),
                                "CUSTODIAN2": custodianTwoId,
                                "CUSTODIAN2_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully forwarded BOT for approval.`
                        }
                    }

                    break;
                case SAFE_CUSTODY_VERIFICATION:
                    //Visible to SC ==> 4: Safe Custody --Custodians
                    if (role === CUSTODIAN_ROLE_ID) {
                        workingStage = { ...workingStage, stage: stage }
                    }

                    //Move to next if role and previous status allows
                    //5 ==> BOT_Verifier
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: BACK_OFFICE_VERIFICATION,
                            extraPatches: {
                                "VERIFIER": userId,
                                "VERIFIED_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully verified and forwarded to Authorizer.`
                        }
                    }
                    break;
                case BACK_OFFICE_VERIFICATION:
                    //Visible to BOT ==> 5: BOT --Verfier
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = { ...workingStage, stage: stage }
                    }
                    //Move to next if role and previous status allows
                    //6 ==> BOT_Verifier
                    if (role === BOT_AUTHORIZER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: BACK_OFFICE_AUTHORIZATION,
                            extraPatches: {
                                "AUTHORIZER": userId,
                                "AUTHORIZED_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully approved.`
                        }
                    }
                    break;
                case BACK_OFFICE_AUTHORIZATION:
                    //Visible to BOT ==> 6: BOT --Authorizer
                    if (role === BOT_AUTHORIZER_ROLE_ID) {
                        workingStage = { ...workingStage, stage: stage }
                    }
                    //Move to next if role and previous status allows
                    if (role === CUSTODIAN_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: SAFE_CUSTODY_DATE_CONFIRMATION,
                            successDisplayMessage: `Intent deposit date successfully confirmed.`
                        }
                    }
                    break;
                case SAFE_CUSTODY_DATE_CONFIRMATION:
                    //Visible to CM ==> 1: to Generate bd55 form,4 = Custodian
                    // if (role === 4) {
                    //     workingStage = {
                    //         ...workingStage,
                    //         stage: stage
                    //     }
                    // }
                    //
                    if (role === CUSTODIAN_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: SAFE_CUSTODY_BDFORM_SUBMIT,
                            action: ACTION_ACCEPT,
                            successDisplayMessage: `Intent filled and signed BD55 form submitted successfully.`
                        }
                    }
                    break;

                case SAFE_CUSTODY_BDFORM_SUBMIT:

                    if (role === CUSTODIAN_ROLE_ID) {
                        workingStage = { ...workingStage, stage: stage }
                    }
                    //Move to next if role and previous status allows
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: (action === ACTION_RETURN) ? SAFE_CUSTODY_DATE_CONFIRMATION : BOT_VERIFIER_CONFIRMATION,
                            successDisplayMessage: (action === ACTION_RETURN) ? `Intent returned to custodian for correction of the BD55 form uploaded.` : `Uploaded filled and signed BD55 form successfully verified.`
                        }
                    }

                    break
                // case SAFE_CUSTODY_REP_DEPOSIT:
                //     //Visible to CM Representatives ==> 7: to Generate bd form,4 = Custodian
                //     if (role === 7) {
                //         workingStage = {
                //             ...workingStage,
                //             stage: stage,
                //             action: (action === ACTION_ACCEPT) ? ACTION_ACCEPT_S2 : action,
                //             extraPatches: {
                //                 "REP2": userId,
                //                 "REP2_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                //             }
                //         }
                //     }
                //     //Move to next if role and previous status allows
                //     if (role === 4) {
                //         workingStage = {
                //             ...workingStage,
                //             stage: SAFE_CUSTODY_SCC_DEPOSIT,
                //             action: (action === ACTION_ACCEPT) ? ACTION_ACCEPT_S1 : action,
                //             extraPatches: {
                //                 "CUSTODIAN1": userId,
                //                 "CUSTODIAN1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                //             }
                //         }
                //     }
                //     break;
                // case SAFE_CUSTODY_SCC_DEPOSIT:
                //     //Visible to SC ==> 4: Custodians
                //     if (role === 4) {
                //         workingStage = {
                //             ...workingStage,
                //             stage: stage,
                //             action: (action === ACTION_ACCEPT) ? ACTION_ACCEPT_S2 : action,
                //             extraPatches: {
                //                 "CUSTODIAN2": userId,
                //                 "CUSTODIAN2_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                //             }
                //         }
                //     }
                //     if (role === 5) {
                //         workingStage = {
                //             ...workingStage,
                //             stage: BOT_VERIFIER_CONFIRMATION,
                //         }
                //     }
                //     break;

                case BOT_VERIFIER_CONFIRMATION:
                    //Visible to BT ==> 5: to Generate bd form,6 = Currency officers
                    //Here the intent is completed and message to be generated to effect CBS Accounts
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: stage
                        }
                    }

                    if (role === BOT_AUTHORIZER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: (action === ACTION_RETURN) ? SAFE_CUSTODY_BDFORM_SUBMIT : BOT_AUTHORIZER_CONFIRMATION,
                            successDisplayMessage: (action === ACTION_RETURN) ? `Intent successfully returned to Verifier for correction.` : `Updated successfully and Transaction forwarded to CBS.`
                        }
                    }
                    break;
                case BOT_AUTHORIZER_CONFIRMATION:
                    //Visible to BT ==> 6: Authorizer for completion

                    if (role === BOT_AUTHORIZER_ROLE_ID & action === ACTION_ACCEPT) {
                        workingStage = {
                            ...workingStage,
                            stage: INTENT_COMPLETED,
                        }
                    }
                    break;
                default:
                    break;
            }
        }

        //Direct Deposit workflow
        if (intentType === DIRECT_DEPOSIT_INTENT) {

            switch (stage) {
                case COMMERCIAL_BANK_SUBMIT:
                    //Visible to CB ==> 1: bank officers --Orignators
                    if (role === COM_INITIATOR_ROLE_ID) {
                        workingStage = { ...workingStage, stage: stage }
                    }
                    //Move to next if role and previous status allows
                    //2 ==> CB Signatory One
                    if (_comSignatories.includes(role)) {
                        workingStage = {
                            ...workingStage,
                            stage: COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION,
                            extraPatches: {
                                "SIGNATORY1": userId,
                                "SIGNATORY1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully forwarded to signatory two for approval.`
                        }
                    }
                    break;
                case COMMERCIAL_BANK_SIGNATORY_ONE_VERIFICATION:
                    //Visible to CB ==> 2: CB --Signatory One
                    if (_comSignatories.includes(role)) {
                        workingStage = {
                            ...workingStage,
                            stage: COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION,
                            extraPatches: {
                                "SIGNATORY2": userId,
                                "SIGNATORY2_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Intent request successfully rejected.` : `Intent request successfully forwarded to BOT for approval.`
                        }
                    }
                    break;
                case COMMERCIAL_BANK_SIGNATORY_TWO_VERIFICATION:
                    //Visible to CB ==> 3: CB --Signatory Two
                    // if (role === COM_SIGNATORY_TWO_ROLE_ID) {
                    //     workingStage = {
                    //         ...workingStage,
                    //         stage: stage
                    //     }
                    // }

                    //Move to next if role and previous status allows
                    //4 ==> SC Custodian
                    if (role === BOT_MANAGER_CURRENCY_OPS) {
                        workingStage = {
                            ...workingStage,
                            stage: BOT_AM_AUTHORIZATION,//,BOT_MANAGER_OP_APPROVAL,
                            extraPatches: {
                                "MANAGER": userId,
                                "MANAGER_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                            },
                            successDisplayMessage: (action === ACTION_REJECT) ? `Deposit intent request successfully rejected.` : `Deposit intent request successfully approved.`
                        }
                    }
                    break;
                // case BOT_MANAGER_OP_APPROVAL:
                //     //Visible to SC ==> 4: Safe Custody --Custodians
                //     if (role === BOT_MANAGER_CURRENCY_OPS) {
                //         workingStage = { ...workingStage, stage: stage }
                //     }

                //     //Move to next if role and previous status allows
                //     //5 ==> BOT_Verifier
                //     if (role === BOT_AUTHORIZER_ROLE_ID) {
                //         workingStage = {
                //             ...workingStage,
                //             stage: BOT_AM_AUTHORIZATION,
                //             extraPatches: {
                //                 "AUTHORIZER": userId,
                //                 "AUTHORIZED_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                //             }
                //         }
                //     }
                //     break;
                case BOT_AM_AUTHORIZATION:
                    //Visible to BOT ==> 5: BOT --Verfier
                    if (role === BOT_AUTHORIZER_ROLE_ID) {
                        workingStage = { ...workingStage, stage: stage }
                    }
                    //Move to next if role and previous status allows
                    //6 ==> BOT_Verifier
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: SAFE_CUSTODY_DATE_CONFIRMATION,
                            extraPatches: {
                                "VERIFIER": userId,
                                "VERIFIED_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss a")
                            },
                            successDisplayMessage: `Intent deposit date successfully confirmed.`
                        }
                    }
                    break;

                case SAFE_CUSTODY_DATE_CONFIRMATION:
                    //Visible to CM ==> 1: to Generate bd form,4 = Custodian
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: stage
                        }
                    }
                    if (role === BOT_AUTHORIZER_ROLE_ID) {
                        workingStage = {
                            ...workingStage,
                            stage: BACK_OFFICE_AUTHORIZATION,
                            extraPatches: {
                                "AUTHORIZER": userId,
                                "AUTHORIZED_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                            },
                            successDisplayMessage: (action === ACTION_RETURN) ? `Intent request successfully returned to Custodian for correction.` : `Intent request successfully verified.`
                        }
                    }
                    break;
                case BACK_OFFICE_AUTHORIZATION:
                    //Visible to BOT ==> 5: BOT --Custodian
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        if (status === ACTION_RETURN) {
                            workingStage = {
                                ...workingStage,
                                stage: SAFE_CUSTODY_DATE_CONFIRMATION,
                                action: ACTION_ACCEPT,
                                extraPatches: {
                                    "VERIFIER": userId,
                                    "VERIFIED_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                                },
                                successDisplayMessage: `Intent deposit date successfully confirmed.`
                            }
                        } else {
                            workingStage = {
                                ...workingStage,
                                extraPatches: {
                                    "CUSTODIAN1": userId,
                                    "CUSTODIAN1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                                },
                                action: ACTION_ACCEPT,
                                stage: SAFE_CUSTODY_BDFORM_SUBMIT,
                                successDisplayMessage: `Intent filled and signed BD55 form submitted successfully.`
                            }
                        }
                    }
                    break;
                case SAFE_CUSTODY_BDFORM_SUBMIT:
                    //Move to next if role and previous status allows
                    if (role === BOT_VERIFIER_ROLE_ID) {
                        if (status === ACTION_RETURN) {
                            workingStage = {
                                ...workingStage,
                                stage: SAFE_CUSTODY_BDFORM_SUBMIT,
                                action: ACTION_ACCEPT,
                                extraPatches: {
                                    "CUSTODIAN1": userId,
                                    "CUSTODIAN1_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                                },
                                successDisplayMessage: `Intent filled and signed BD55 form submitted successfully.`
                            }
                        } else {
                            workingStage = {
                                ...workingStage,
                                stage: (action === ACTION_RETURN) ? SAFE_CUSTODY_BDFORM_SUBMIT : BOT_AUTHORIZER_CONFIRMATION,
                                extraPatches: {
                                    "CUSTODIAN2": userId,
                                    "CUSTODIAN2_DATE": moment(new Date()).format("DD-MMM-YY h:mm:ss A")
                                },
                                successDisplayMessage: (action === ACTION_RETURN) ? `Intent returned to custodian One for correction of the BD11 form submitted.` : `Uploaded filled and signed BD55 form successfully verified.`
                            }
                        }
                    }
                    break
                default:
                    workingStage = { ...workingStage, stage: stage }
                    break;
            }
        }
    }

    return workingStage;

}


const intentCancelOrRejectReasons = (role) => {
    return [
        { value: "Wrong amount funded", onlyVisibleTo: [BOT_VERIFIER_ROLE_ID] },
        { value: "Wrong Series Category", onlyVisibleTo: [] },
        { value: "Mixed Series in a Bundle", onlyVisibleTo: [CUSTODIAN_ROLE_ID, BOT_VERIFIER_ROLE_ID] },
        { value: "Mixed Denomination in a Bundle", onlyVisibleTo: [CUSTODIAN_ROLE_ID, BOT_VERIFIER_ROLE_ID] },
        { value: "Wrong Denomination Type", onlyVisibleTo: [] },
        { value: "Absence of representative", onlyVisibleTo: [COM_INITIATOR_ROLE_ID] },
        { value: "System faults eg network", onlyVisibleTo: [] },
        { value: "Change in intent amount and denominations", onlyVisibleTo: [COM_INITIATOR_ROLE_ID] },
        { value: "Unauthorized of representative", onlyVisibleTo: [CUSTODIAN_ROLE_ID, BOT_VERIFIER_ROLE_ID] },
        { value: "Amount exceeds operation limit", onlyVisibleTo: [CUSTODIAN_ROLE_ID, BOT_VERIFIER_ROLE_ID] },
        { value: "Other", onlyVisibleTo: [] }
    ].filter((x) => x.onlyVisibleTo.length === 0 || x.onlyVisibleTo.includes(role));
}

export {
    reverseString,
    formatNumber,
    formatNumber2,
    unformatNumber,
    base64FileDetails,
    tokenDecode,
    strTrim,
    weekDates,
    intentStatus,
    getAllStagesByRole,
    intentWorkingStage,
    stageApprovalButtons,
    stageApprovalButtonsDirectBanking,
    getCustomConsignmentStatus,
    getOriginalConsignmentStatus,
    randomizePwd,
    getPasswordAge,
    translateEnteredAmount,
    intentCancelOrRejectReasons
}
